/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAddressCard} from '@fortawesome/pro-duotone-svg-icons';

const DemographicsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faAddressCard} {...props} />
);

export default DemographicsIcon;
